import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createPageTranslation: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    isAddModalVisible: false,
    fields: new (Record({
      locale: "",
      name: "",
      slug: "",
      pageUID: null,
      templateUID: "",
      pageListUID: "",
      sort: 10
    }))()
  }))(),
  createPageTranslationField: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      name: "",
      placeholder: "",
      value: "",
      fieldType: ""
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/pageTranslations/forms.js